const CHAVE = 'cb_admin_sessao';
const ouvintes = new Set();

export function sessao() {
  try { return JSON.parse(localStorage.getItem(CHAVE) || 'null'); } catch { return null; }
}
export function salvarSessao(s) {
  try { s ? localStorage.setItem(CHAVE, JSON.stringify(s)) : localStorage.removeItem(CHAVE); } catch {}
  ouvintes.forEach(f => f(s));
}
// App.jsx escuta aqui para trocar de tela sem precisar de F5
export function aoMudarSessao(f) {
  ouvintes.add(f);
  return () => ouvintes.delete(f);
}

export async function api(caminho, opcoes = {}) {
  const s = sessao();
  const headers = { 'Content-Type': 'application/json', ...(opcoes.headers || {}) };
  if (s && s.token) headers.Authorization = 'Bearer ' + s.token;
  let resp;
  try {
    resp = await fetch('/api/admin' + caminho, {
      method: opcoes.method || 'GET',
      headers,
      body: opcoes.body !== undefined ? JSON.stringify(opcoes.body) : undefined,
    });
  } catch {
    throw new Error('Sem conexão com o servidor');
  }
  let dados = null;
  try { dados = await resp.json(); } catch {}
  if (resp.status === 401 && caminho !== '/login') {
    salvarSessao(null);
    throw new Error((dados && dados.erro) || 'Sessão expirada');
  }
  if (!resp.ok) throw new Error((dados && dados.erro) || 'Erro ' + resp.status);
  return dados;
}

export const moeda = v => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const moedaCurta = v => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1000) return 'R$ ' + (n / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + ' mil';
  return 'R$ ' + n.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
};
export const inteiro = v => Number(v || 0).toLocaleString('pt-BR');
export const dataBR = d => {
  if (!d) return '—';
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : s;
};
export const dataHoraBR = d => {
  if (!d) return '—';
  const dt = new Date(d);
  if (isNaN(dt)) return dataBR(d);
  return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};
export const diasAte = d => {
  if (!d) return null;
  const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const alvo = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
  return Math.round((alvo - hoje) / 86400000);
};
export const SITUACAO = {
  trial: 'Teste grátis',
  ativo: 'Ativo',
  suspenso: 'Suspenso',
  cancelado: 'Cancelado',
};
export const PERFIS = { admin: 'Administrador', operador: 'Operador', motorista: 'Motorista' };
export const MODULOS = { banheiros: 'Banheiros químicos', fossa: 'Limpa-fossa' };
export const UFS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

export function gerarSenha(tam = 8) {
  const letras = 'abcdefghjkmnpqrstuvwxyz23456789';
  let s = '';
  for (let i = 0; i < tam; i++) s += letras[Math.floor(Math.random() * letras.length)];
  return s;
}
export async function copiar(texto) {
  try { await navigator.clipboard.writeText(texto); return true; } catch { return false; }
}

// Campos do tenant podem variar — pega o primeiro que existir
export const nomeTenant = t => t.nome || t.razao_social || t.nome_fantasia || t.empresa || `Empresa #${t.id}`;
export const emailTenant = t => t.email || t.email_contato || t.email_responsavel || '';
export const telefoneTenant = t => t.whatsapp || t.telefone || t.celular || '';
export const criadoTenant = t => t.criado_em || t.created_at || t.data_cadastro || null;
